<app-blade-header [bladeIndex]="bladeIndex" (closeClicked)="closeBlade()">
  @if (title$ | async; as title) {
    <ng-container title>
      {{title}}
    </ng-container>
  }

  @if (isOpenTrafficDeviationVisible$ | async) {
    <div actions class="open-traffic-deviation">
      <button type="button" mat-button (click)="openTrafficDeviation()">
        {{ 'New deviation' | translate }}
      </button>
    </div>
  }
</app-blade-header>

@if (vehicleActivity) {
  <div class="large-properties highlight-background">
    <div class="property">
      <div class="label"><i class="fas fa-clock"></i> <span translate>Time</span></div>
      <div class="value">{{time}}</div>
    </div>
    <div class="property">
      <div class="label"><i class="fas fa-route"></i> <span translate>Route</span></div>
      <div class="value">{{routeNumber}}</div>
    </div>
    <div class="property">
      <div class="label"><i class="fas fa-code-branch"></i> <span translate>Trip</span></div>
      <div class="value">{{tripNumber}}</div>
    </div>
    <div class="property property-tag">
      <div class="tag" [style.background-color]="activityTypeColor">
        {{activityType}}
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if (vehicleActivity?.activityPoints && vehicleActivity?.activityPoints.length > 0) {
    <div class="vehicle-trip-info"
      >
      <div class="header">
        <div class="text" translate>
          Stop
        </div>
        <div class="text" translate>
          Departure
        </div>
      </div>
      <div class="items">
        @for (item of vehicleActivity?.activityPoints; track item) {
          <div class="item" [class.timing-point]="item.isTimingPoint">
            <div class="stop-description">
              {{item?.stopDescription}}
              @if (item?.platformCode) {
                ({{item?.platformCode}})
              }
            </div>
            <div class="departure">
              @if (item?.isTimingPoint) {
                <i class="far fa-clock"></i>
              }
              {{item?.departureTime}}
            </div>
          </div>
        }
      </div>
    </div>
  }
}